
import {
  Component, Emit, Prop, ProvideReactive, Vue,
} from 'nuxt-property-decorator'
import BaseTabElement, { ITab } from './BaseTabElement.vue'
import { getAnchorLinkText, splitBySpace } from '../../../shared/general/services/AnchorLinkService'

@Component({
  name: 'BaseTab',
  components: { BaseIcon: () => import('../BaseIcon.vue') },
})
export default class BaseTab extends Vue {
  @Prop({ default: false }) fullWidth! : boolean

  @Prop({ default: true }) wrap! : boolean

  @Prop({ default: false }) hideTitleMobile! : boolean

  @Prop({ default: '' }) customClasses! : string

  @ProvideReactive('tab') tab : ITab = {
    count: 0,
    active: 0,
  }

  private tabs : BaseTabElement[] = []

  private currentIndex : number = 0

  private timeout ?: ReturnType<typeof setTimeout>

  mounted () {
    this.tabs = this.$children as BaseTabElement[]

    this.$nextTick(() => {
      this.checkAnchorLinkOpenTabByTitle()
    })
  }

@Emit('tab-click')
  private selectTab (index : number) : number {
    const location = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
    window.history.pushState({}, document.title, `${location}#accordion_${this.tabs[index].title}${window.location.search}`)

    this.currentIndex = index
    this.tab.active = index

    return index
  }

private setActiveIndex (index : number) : void {
  this.currentIndex = index

  this.$nextTick().then(() => {
    this.timeout = setTimeout(() => {
      (this.$refs.tabs as any)?.[index]?.click()
    }, 100)
  })
}

  @Emit('unmounted-index')
destroyed () {
  if (this.timeout) clearTimeout(this.timeout)
  return this.currentIndex + 1
}

  private checkAnchorLinkOpenTabByTitle () : void {
    const anchorText = getAnchorLinkText('#accordion_', true)
    const equalsAnchorText = (tab : BaseTabElement) : boolean => {
      if (!tab.title) return false
      const titles = splitBySpace(tab.title, true)
      return titles.every((title) => anchorText.includes(title))
    }

    const index = this.tabs.findIndex(equalsAnchorText)
    if (index > 0) (this.$refs.tabs as BaseTabElement)[index]?.click()
  }
}
